jQuery(document).ready(function($){

    $(document).on('change', ".news-search-field", function(){
        $(".news-form").submit();
    });

});